var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrowseIcon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.20932 21.3182C3.57353 19.3687 3.8285 16.4544 5.77796 14.8186L10.3381 10.9922L8.52055 8.82614L3.96042 12.6525C0.813927 15.2928 0.40304 19.9892 3.04326 23.1357C5.68348 26.2822 10.3799 26.6931 13.5264 24.0529L18.0866 20.2265L16.269 18.0604L11.7089 21.8868C9.75943 23.5226 6.84511 23.2676 5.20932 21.3182ZM10.8401 18.5361L19.9603 10.8833L18.0471 8.60326L8.92686 16.2561L10.8401 18.5361ZM15.3607 3.08653L10.8006 6.91294L12.6182 9.079L17.1783 5.25259C19.1277 3.61681 22.0421 3.87178 23.6779 5.82123C25.3136 7.77069 25.0587 10.685 23.1092 12.3208L18.5491 16.1472L20.3666 18.3133L24.9268 14.4869C28.0732 11.8466 28.4841 7.15018 25.8439 4.00369C23.2037 0.8572 18.5072 0.446313 15.3607 3.08653Z",
    fill: "#FE4A23",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowseIcon02);
export default __webpack_public_path__ + "static/media/browse-icon-02.02289ea43611f9d6ef37dae8bbb17c10.svg";
export { ForwardRef as ReactComponent };